// ABOUTME: Icon component for stacked chart mode (separate grids)
// ABOUTME: Shows three horizontal lines representing separate chart areas

import type { FC } from "react"

interface ChartStackedIconProps {
  className?: string
  size?: number
  color?: string
}

export const ChartStackedIcon: FC<ChartStackedIconProps> = ({ className, size = 16, color = "currentColor" }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Three horizontal lines representing stacked grids */}
      <rect
        x="2"
        y="2"
        width="12"
        height="3"
        rx="0.5"
        fill={color}
      />
      <rect
        x="2"
        y="6.5"
        width="12"
        height="3"
        rx="0.5"
        fill={color}
      />
      <rect
        x="2"
        y="11"
        width="12"
        height="3"
        rx="0.5"
        fill={color}
      />
    </svg>
  )
}
